<template>
  <div>
<!--    <div class="cooperation_wrap">-->
<!--      <div class="cooperation_tit">旗下品牌</div>-->
<!--      <div class="cooperation_box">-->
<!--        <div class="cooperation_item">-->
<!--          &lt;!&ndash; 动态生成的多行四列布局 &ndash;&gt;-->
<!--          <el-row>-->
<!--            <el-col :span="6"-->
<!--                    v-for="(item, colIndex) in brandList"-->
<!--                    :key="colIndex"-->
<!--                    @click.native="handleBrandClick(item)"-->
<!--            >-->
<!--              <div class="image-card">-->
<!--                <img :src="item.src" alt=""/>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


<!--    <div class="cooperation_wrap_video">-->
<!--      <div class="cooperation_tit_video">品牌视频</div>-->
<!--      <div class="cooperation_box_video">-->
<!--        <div class="cooperation_item_video">-->
<!--          &lt;!&ndash; 主视频播放器 &ndash;&gt;-->
<!--          <div class="video-player-card">-->
<!--            <div class="video-player">-->
<!--              <video-->
<!--                  ref="videoPlayer"-->
<!--                  :src="currentVideo.url"-->
<!--                  controls-->
<!--                  poster="../../../assets/img/video/video_cover.jpg"-->
<!--              ></video>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="scroll_wrap_overflow_tit">
      新闻中心
    </div>
    <!-- 新闻中心核心容器：仅保留原始结构，修改样式实现滑动 -->
    <div class="scroll_wrap_overflow">
      <div class="scroll_content">
        <el-row class="scroll_wrap">
          <el-col
              class="scroll_item"
              v-for="(item, index) in newsList"
              :key="index"
              @click.native="handleNewsClickCore(item)"
          >
            <div class="scroll_img">
              <img class="full_img" :src="item.second[0]?.src" alt=""/>
            </div>
            <div class="scroll_txt">
              <div class="scroll_txt_index">
                {{ index < 10 ? `0${index + 1}` : index + 1 }}
              </div>
              <div class="scroll_txt_title">
                {{ item.second[0].name }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>

</template>

<script>
import {getBrandList, getJournalism} from "@/api/home";

export default {
  data() {
    return {
      // 当前播放的视频
      currentVideo: {
        title: "品牌视频",
        description: "璟点集团",
        url:require("@/assets/img/video/brandVideo.mp4"),
        thumbnail: "",
        duration: 120
      },
      newsList: [],//新闻中心数组
      brandList: [],//旗下品牌数组
      // 常量配置（便于统一维护）
      CONST: {
        API_TYPE: "home_news",
      }
    }
  },
  created() {
    //获取新闻中心列表信息
    this.fetchJournalism();
    //获取旗下品牌列表信息
    this.getBrandList();
  },
  methods: {
    /**
     * 请求后端Java接口，获取新闻中心列表
     */
    async fetchJournalism() {
      try {
        this.loading = true;
        const res = await getJournalism();
        if (res.code === 200) {
          // 数据格式化：确保second数组存在，避免报错
          this.newsList = (res.data || []).map(tabItem => ({
            ...tabItem,
            name: tabItem.name || '', // Tab名称兜底
            second: (tabItem.second || []).map(imgItem => ({
              ...imgItem,
              name: imgItem.name,
              src: imgItem.src || '',     // 图片地址兜底
              url: imgItem.url || '',     // 跳转链接兜底
              urlType: Number(imgItem.urlType) || 0 // 转换为数字，兜底0
            }))
          }));

        } else {
          this.$message.error(res.returnMsg || "获取产品列表失败");
          this.coresList = [];
        }
      } catch (error) {
        console.error("产品列表请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
        this.coresList = [];
      } finally {
        this.loading = false;
      }
    },

    // 新闻点击核心逻辑
    handleNewsClickCore(item) {
      // 空数据兜底
      if (!item || !item.second || item.second.length === 0) {
        this.$message.warning("该新闻暂无跳转链接");
        return;
      }

      const targetItem = item.second[0];
      const { url, urlType } = targetItem;

      try {
        // 1. 外部链接（urlType=1）
        if (urlType === 1) {
          console.log(151,url);
          // if (!url || !/^https?:\/\//.test(url)) {
          //   this.$message.warning("外部链接格式错误，请检查");
          //   return;
          // }else{
          //
          // }
          window.open(url, '_blank', 'noopener,noreferrer');
        }
        // 2. 内部路由（urlType=2）
        else if (urlType === 2) {
          if (!url && !targetItem.id) {
            this.$message.warning("缺少跳转参数");
            return;
          }
          this.$router.push({
            path: '/newsDetail',
            query: {
              newsId: targetItem.id,
              type: this.CONST.API_TYPE
            }
          });
        }
        // 3. 无跳转类型
        else {
          this.$message.info("该新闻暂无跳转链接");
        }
      } catch (error) {
        console.error("新闻跳转失败：", error);
        this.$message.error("跳转失败，请稍后重试");
      }
    },
    /**
     * 请求后端Java接口，获取旗下列表
     */
    async getBrandList() {
      try {
        this.loading = true;
        const res = await getBrandList();
        if (res.code === 200) {
          this.brandList = res.data || [];
        } else {
          this.$message.error(res.returnMsg || "获取产品列表失败");
          this.brandList = [];
        }
      } catch (error) {
        console.error("产品列表请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
        this.brandList = [];
      } finally {
        this.loading = false;
      }
    },

    // 旗下品牌点击核心逻辑
    handleBrandClick(item) {
      console.log(199,item);
      // 空数据兜底
      if (!item) {
        this.$message.warning("该品牌暂无跳转链接");
        return;
      }

      const { url, urlType } = item;

      try {
        // 1. 外部链接（urlType=1）
        if (urlType === '1') {
          if (!url || !/^https?:\/\//.test(url)) {
            this.$message.warning("外部链接格式错误，请检查");
            return;
          }
          window.open(url, '_blank', 'noopener,noreferrer');
        }
        // 2. 内部路由（urlType=2）
        else if (urlType === '2') {
          if (!url && !item.id) {
            this.$message.warning("缺少跳转参数");
            return;
          }
          this.$router.push({
            path: '/productDetail',
            query: {
              productId: item.id,
              type: 'brand'
            }
          });
        }
        // 3. 无跳转类型
        else {
          this.$message.info("该品牌暂无跳转链接");
        }
      } catch (error) {
        console.error("品牌跳转失败：", error);
        this.$message.error("跳转失败，请稍后重试");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.lichengbei_pic {
  width: 100%;
  height: 500px;
  margin-top: 150px;
}
.cooperation_wrap {
  width: 100%;
  background-size: 100% 100%;
  .cooperation_tit {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
    padding-top: 185px;
    margin-left: 160px;
    @media screen and (max-width: 1024px) { // 平板+移动端适配
      font-size: 1.2rem;
      margin-left: 20px;
      padding-top: 80px;
    }
  }
  .cooperation_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    margin-top: 30px;
    @media screen and (max-width: 1024px) {
      font-size: 0.8rem;
    }
  }
  .cooperation_box {
    width: 100%;
    margin: 0 auto;
    padding-top: 70px;
    position: relative;
    @media screen and (max-width: 1024px) {
      width: 100%;
    }
    .cooperation_item {
      img {
        width: 100%;
      }
    }
  }
}

//品牌视频样式、
.cooperation_wrap_video {
  width: 100%;
  background-size: 100% 100%;
  text-align: center;
  .cooperation_tit_video {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
    padding-top: 130px;
    @media screen and (max-width: 1024px) {
      font-size: 1.2rem;
      padding-top: 80px;
    }
  }
  .cooperation_desc_video {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    margin-top: 30px;
    @media screen and (max-width: 1024px) {
      font-size: 0.8rem;
    }
  }
  .cooperation_box_video {
    width: 100%;
    margin: 0 auto;
    padding-top: 75px;
    position: relative;
    @media screen and (max-width: 1024px) {
      width: 90%;
    }
    .cooperation_item_video {
      img {
        width: 100%;
      }
    }
  }
}

.image-card {
  height: 220px;
  overflow: hidden;
  border: #c1c1c1 1px solid;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
}
.image-card img {
  padding: 0 40px;
  width: 200px;
  height: 100px;
  object-fit: contain;
  transition: transform 0.5s ease;
}

//品牌视频样式
.video-player-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 1250px;
  margin: 0 auto;
  @media screen and (max-width: 1024px) {
    width: 90%;
  }
}
.video-player {
  width: 100%;
  background: #000;
  aspect-ratio: 16/9;
  position: relative;
}
.video-player video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.video-info {
  padding: 15px;
}
.video-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.video-item {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
}
.video-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}
.video-thumbnail {
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  background: #000;
}
.video-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.video-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
}
.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(255, 255, 255, 0.8);
  font-size: 48px;
  opacity: 0.8;
  transition: all 0.3s;
}
.video-item:hover .video-play-icon {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1.1);
}
.video-item-info {
  padding: 10px;
}
.video-item-title {
  font-weight: 600;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.video-item-desc {
  font-size: 12px;
  color: #909399;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.video-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
.quality-selector {
  width: 120px;
}

//新闻中心 - 核心修改：支持移动端/平板横向滑动，无箭头
.scroll_wrap_overflow_tit {
  width: 100%;
  font-size: 40px;
  font-weight: bold;
  color: #3e3e3e;
  padding: 180px 0 50px 160px; // 调整底部间距，更适配滑动布局
  @media screen and (max-width: 1024px) { // 平板+移动端适配
    font-size: 1.2rem;
    padding: 80px 0 30px 20px;
    margin: 0;
  }
}
.scroll_wrap_overflow {
  width: 100%;
  overflow: hidden; // 外层隐藏溢出，仅内层滚动
  padding: 0 20px 40px; // 增加底部间距，避免遮挡
  box-sizing: border-box;
  @media screen and (max-width: 1024px) {
    width: 100%;
    padding: 0 10px 30px;
  }
  .scroll_content {
    border-radius: 8px;
    .scroll_wrap {
      width: max-content; // 宽度自适应内容，确保横向排列
      display: flex;
      gap: 35px; // 新闻项间距
      // 核心：移动端/平板横向滚动配置
      @media screen and (max-width: 1024px) {
        width: max-content;
        gap: 15px; // 缩小移动端间距
      }
    }
    // 滚动容器：核心滑动层
    &::-webkit-scrollbar {
      display: none; // 全局隐藏滚动条（关键）
    }
    -webkit-overflow-scrolling: touch; // 移动端顺滑滑动（关键）
    overflow-x: auto; // 横向滚动（关键）
    overflow-y: hidden; // 垂直方向禁止滚动
    scrollbar-width: none; // 火狐隐藏滚动条
    -ms-overflow-style: none; // IE隐藏滚动条
  }
  .scroll_item {
    width: 425px; // 固定新闻项宽度（原始尺寸）
    flex-shrink: 0; // 禁止压缩，确保宽度固定（关键）
    cursor: pointer;
    @media screen and (max-width: 1024px) {
      width: 280px; // 平板/移动端缩小新闻项宽度
    }
    @media screen and (max-width: 768px) {
      width: 220px; // 手机端进一步缩小
    }
    .scroll_img {
      width: 100%;
      height: 550px;
      border-radius: 8px;
      overflow: hidden;
      box-sizing: border-box;
      @media screen and (max-width: 1024px) {
        height: 300px; // 平板缩小图片高度
      }
      @media screen and (max-width: 768px) {
        height: 290px; // 手机端进一步缩小
      }
      .full_img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }
    .scroll_txt {
      width: 100%; // 宽度跟随父元素
      border-radius: 8px;
      height: 118px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      background: linear-gradient(134deg, #1E6AB8FF 1%, #0E51A4FF 41%, #013F95FF 99%);
      @media screen and (max-width: 1024px) {
        height: 80px; // 平板缩小文本高度
        gap: 10px;
      }
      @media screen and (max-width: 768px) {
        height: 70px; // 手机端进一步缩小
        gap: 5px;
      }
      .scroll_txt_index{
        height: 150px;
        padding-left: 20px;
        width: 20%;
        font-size: 70px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        color: transparent;
        -webkit-text-stroke: 3px #1e6fff;
        @media screen and (max-width: 1024px) {
          font-size: 40px; // 平板缩小序号字体
          -webkit-text-stroke: 2px #1e6fff;
          padding-left: 10px;
          height: 80px;
        }
        @media screen and (max-width: 768px) {
          font-size: 30px; // 手机端进一步缩小
          -webkit-text-stroke: 1px #1e6fff;
          padding-left: 5px;
          height: 70px;
        }
      }
      .scroll_txt_title{
        height: 150px;
        padding-left: 20px;
        width: 80%;
        font-size: 16px;
        line-height: 1.5;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (max-width: 1024px) {
          font-size: 14px; // 平板缩小标题字体
          padding-left: 10px;
          height: 80px;
        }
        @media screen and (max-width: 768px) {
          font-size: 12px; // 手机端进一步缩小
          padding-left: 5px;
          height: 70px;
          text-align: left;
        }
      }
    }
  }
}
</style>